import IconStarYellow from '@listening/assets/icons/icon-star-yellow.svg?react';
import authScreen from '@listening/assets/imgs/auth-screen.jpg';
import type { ReactNode } from 'react';
import * as m from '@/paraglide/messages';

export function AuthCard({ children }: { children: ReactNode }) {
  return (
    <div className='fixed inset-0 z-50 overflow-y-auto bg-white dark:bg-gray-900'>
      <div className='flex min-h-screen flex-col justify-center py-6 sm:py-12'>
        <div className='relative px-4 py-3 sm:mx-auto sm:max-w-[1200px]'>
          <div className='relative grid w-full grid-cols-1 overflow-hidden rounded-2xl bg-white shadow-[0px_2px_20px_0px_rgba(8,1,36,0.05)] lg:grid-cols-2 lg:gap-6 dark:bg-gray-800/95'>
            <div className='relative hidden overflow-hidden rounded-2xl lg:block'>
              <img
                alt='Authentication'
                className='size-full object-cover'
                src={authScreen}
              />
              <div className='absolute inset-0 bg-linear-to-r from-black/50 to-transparent'>
                <div className='flex h-full flex-col justify-center p-12'>
                  <div className='mb-6 flex items-center space-x-2'>
                    <IconStarYellow className='size-5' />
                    <IconStarYellow className='size-5' />
                    <IconStarYellow className='size-5' />
                    <IconStarYellow className='size-5' />
                    <IconStarYellow className='size-5' />
                  </div>
                  <h2 className='font-jakarta text-5xl leading-tight font-bold text-white'>
                    {m.auth_hero_save_time()}
                    <br />
                    {m.auth_hero_by_listening()}
                    <br />
                    {m.auth_hero_to_papers()}
                    <br />
                    {m.auth_hero_anywhere()}
                  </h2>
                </div>
              </div>
            </div>

            <div className='flex flex-col px-4 py-6 sm:px-8 sm:py-9 lg:pl-10'>
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
